import { render, staticRenderFns } from "./iconSubtotal.vue?vue&type=template&id=0afaac20&scoped=true"
import script from "./iconSubtotal.vue?vue&type=script&lang=js"
export * from "./iconSubtotal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afaac20",
  null
  
)

export default component.exports